import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import orderService from './service';

export const useOrder = () => {
  return useService(orderService, (state) => state);
};

export const useOrderWithKeys = getUseServiceWithSubscriptionKeys(orderService);

export { orderService };
